<template>
    <div class="peripheralEdit">
      <el-card>
        <div class="jump-btn">
          <el-button type="primary" @click="back">{{$t('lang.btn_returnPeripheral')}}</el-button>
        </div>
        <el-form ref="ruleForm" :rules="rules" :model="ruleForm" class="wid100" :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon">
            <el-form-item :label="$t('lang.lab_marchantNames')" prop="name" class="item-width">
                <el-input v-model="ruleForm.name" :placeholder="$t('lang.lab_plaMarchantDetail50')" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item :label="$t('lang.lab_telephoneNum')" prop="phone" class="item-width">
                <el-input @input="keyTP" v-model="ruleForm.phone" :placeholder="$t('lang.lab_plaMarchantName50')"  maxlength="11"></el-input>
            </el-form-item>
            <el-form-item :label="$t('lang.lab_detailAdd')" prop="address" class="item-width">
                <el-input v-model="ruleForm.address" :placeholder="$t('lang.lab_plaDetailAdd200')" 
                type="textarea" maxlength="200"></el-input>
            </el-form-item>
            <el-form-item :label="$t('lang.lab_alleyeAdd')" prop="alleye" class="item-width">
                <el-input v-model="ruleForm.alleye" :placeholder="$t('lang.lab_plaAlleyeAdd')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('lang.lab_sort')" prop="orderby">
                <el-input-number v-model="ruleForm.orderby" :placeholder="$t('lang.lab_sort')" controls-position="right" :min="1"></el-input-number>
            </el-form-item>
            <el-form-item :label="$t('lang.lab_marchantLogo')" prop="imgurl" ref="imgurl">
                <upload-file ref="uploading" :accept='accept'  upTypes='1' :fileList='fileList' :clears='clears' @outputFile="getFile" @removeFile='removeFile'></upload-file>
            </el-form-item>
            <el-form-item :label="$t('lang.lab_serviceType')" prop="typeid">
                <el-select v-model="ruleForm.typeid" :placeholder="$t('lang.lab_serviceType')">
                    <el-option key :label="$t('lang.lab_plaServiceType')" value></el-option>
                    <el-option
                      v-for="(item,index) in serviceTypes"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('lang.lab_recommendedStatus')" prop="recommend">
              <el-radio-group v-model="ruleForm.recommend">
                <el-radio :label="0">{{$t('lang.lab_normalStatus')}}</el-radio>
                <el-radio :label="1">{{$t('lang.lab_recommended')}}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('lang.lab_preferentialStatus')" prop="preferential">
              <el-radio-group v-model="ruleForm.preferential">
                <el-radio :label="0">{{$t('lang.lab_normalStatus')}}</el-radio>
                <el-radio :label="1">{{$t('lang.lab_preferential')}}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('lang.lab_marchantDetail')" prop="reverse2" class="item-width">
              <quill-editor v-model="ruleForm.reverse2" ref="myQuillEditor" :options="editorOption" @change="onEditorChange($event)"></quill-editor>
              <span class="editorText" v-show="isLength < 10001">{{$t('lang.lab_editor_tip1')}}{{isLength}}{{$t('lang.lab_editor_tip2')}}{{10000-isLength}}{{$t('lang.lab_editor_tip3')}}</span>
              <span class="editorTextTips" v-show="isLength >= 10001">{{$t('lang.lab_editor_tips')}}</span>
            </el-form-item>
            <el-button class="btn-first" @click="resetForm('ruleForm')">{{$t('lang.btn_rest')}}</el-button>
            <el-button class="detailbtn" type="primary" @click="save('ruleForm')" :disabled="isDisabled">{{$t('lang.btn_save')}}</el-button>
        </el-form>
      </el-card>
    </div>
</template>

<script>
/**
 *@ClassName:peripheralEdit
 *@Description:周边服务-编辑/新增
 *@author:宋莎
 *@Copyright:格众科技
 *@date:2020-03-06
 */
// 引入富文本title汉字
import UploadFile from '../../../components/upload_file.vue'
import { addQuillTitle } from '../../../config/quill-title.js'
export default {
  data() {
    return {
      saveData: '',
      accept: '.jpg, .jpeg, .png',
      fileList: [], // 图片上传
      clears: false, // 清空按钮
      isDisabled: true, // 保存的可点击
      isFlag: false, // 编辑:true 新增：false
      isLength: 0, // 富文本字数长度
      ruleForm: {
        id: '', // 序号
        gardenid: '', // 小区范围
        typeid: '', // 服务类型
        name: '', // 商家名称
        phone: '', // 联系方式
        address: '', // 地址
        imgurl: '', // 图片
        recommend: 0, // 推荐状态
        preferential: 0, // 优惠状态
        reverse2: '', // 商家详情
        alleye: '', // 全景地址
        orderby: '', // 排序
        avatar: '', // 图片缓存
      },
      rules: {
        name: [{ required: true, message: this.$i18n.t('lang.lab_plaMarchantNames'), trigger: 'blur' }],
        phone: [{ required: true, message: this.$i18n.t('lang.lab_plaTelephoneNum'), trigger: 'blur' }],
        address: [{ required: true, message: this.$i18n.t('lang.lab_plaDetailAdd'), trigger: 'blur' }],
        typeid: [{ required: true, message: this.$i18n.t('lang.lab_plaServiceType'), trigger: 'change' }],
        imgurl: [{ required: true, message: this.$i18n.t('lang.lab_pleaseUploadPhotograph'), trigger: 'change' }],
      },
      serviceTypes: [], // 服务类型
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
            ['blockquote', 'code-block'], // 引用，代码块
            [{ 'header': 1 }, { 'header': 2 }], // 标题，键值对的形式；1、2表示字体大小
            [{ 'list': 'ordered' }, { 'list': 'bullet' }], // 列表
            [{ 'script': 'sub' }, { 'script': 'super' }], // 上下标
            [{ 'indent': '-1' }, { 'indent': '+1' }], // 缩进
            [{ 'direction': 'rtl' }], // 文本方向
            [{ 'size': ['small', false, 'large', 'huge'] }], // 字体大小
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }], // 几级标题
            [{ 'color': [] }, { 'background': [] }], // 字体颜色，字体背景颜色
            [{ 'font': [] }], // 字体
            [{ 'align': [] }], // 对齐方式
            ['clean'], // 清除字体样式
            ['image', 'video'] // 上传图片、上传视频
          ]
        },
        theme: 'snow',
        placeholder: this.$i18n.t('lang.lab_text'),
      },
    }
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill
    }
  },
  components: {
		'upload-file': UploadFile
  },
  destroyed() {
    window.localStorage.setItem('peripheralEditform', JSON.stringify(this.ruleForm))
    window.localStorage.setItem('peripheralEditsaveData', JSON.stringify(this.saveData))
  },
  created() {
    this.service()
    // 判断编辑与新增
    this.isFlag = this.$route.query.flag
      if (window.localStorage.getItem('peripheralEditform')) {
      this.ruleForm = JSON.parse(window.localStorage.getItem('peripheralEditform'))
      if (this.ruleForm.imgurl) {
         this.fileList.push({
            name: '',
            url: this.ruleForm.imgurl
          })
      }
       if (window.localStorage.getItem('peripheralEditsaveData')) {
        this.saveData = JSON.parse(window.localStorage.getItem('peripheralEditsaveData'))
       }
    } else {
    if (this.isFlag) {
      this.getData()
      if (this.ruleForm.recommend === null) {
        this.ruleForm.recommend = 0
      }
      if (this.ruleForm.preferential === null) {
        this.ruleForm.preferential = 0
      }
    } else {
      this.ruleForm.gardenid = this.$store.getters.gardenId
      this.fileList = []
    }
    }
  },
  watch: {
    ruleForm: {
      handler(newVal, oldVal) {
        // ruleForm数据变化时 会调用此方法
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          // 没变
          this.isDisabled = true
        } else {
          // 变了
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
        // 获取组件值
    getFile(e) {
      this.ruleForm.imgurl = e
      this.$refs.imgurl.clearValidate()
    },
    // 移除图片
    removeFile(e) {
      this.fileList = []
      this.ruleForm.imgurl = ''
    },
    // 编辑页直接修改文件
    checkEdit() {
      if (this.isFlag) {
        this.fileList = []
      }
    },
    // 周边服务编辑页面获取数据
    getData() {
      // 这是用来双向绑定
      this.ruleForm = this.$route.query
      if (this.$route.query.imgurl && this.$route.query.imgurl != '') {
        this.fileList.push({
          name: '',
          url: this.$route.query.imgurl.toString()
        }) 
      }
      // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
      this.saveData = JSON.stringify(this.ruleForm)
    },
    // 获取服务类型
    service() {
      let loading = this.$loading()
      this.$get(`/serviceTypes`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.serviceTypes = res.list
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 返回
    back() {
      this.$router.push({ name: 'peripheralList' })
    },
    // 保存
    save(formName) {
      let params = { }
      if (this.isFlag) {
        params.id = this.ruleForm.id
      }
      params.gardenid = this.ruleForm.gardenid
      params.typeid = this.ruleForm.typeid
      params.name = this.ruleForm.name
      params.phone = this.ruleForm.phone
      params.address = this.ruleForm.address
      params.imgurl = this.ruleForm.imgurl
      params.recommend = this.ruleForm.recommend
      params.preferential = this.ruleForm.preferential
      params.reverse2 = this.ruleForm.reverse2
      params.alleye = this.ruleForm.alleye
      params.orderby = this.ruleForm.orderby
      // params.avatar = this.ruleForm.imgurl

      this.$refs[formName].validate((valid) => {
        if (valid) {
          let loading = this.$loading()
          this.$postJson(`/gardenservice/edit`, params).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.$message.success(this.$i18n.t('lang.lab_save_success'))
              var index = this.$keepAlive.indexOf('/manage/main.gardenservice')
              if (index > -1) {
                this.$keepAlive.splice(index, 1)
              }
              this.$router.push({ name: 'peripheralList' })
            }
          },
          error => {
            loading.close()
            if (error === this.$i18n.t('lang.CODE102')) {
              this.$message.error(this.$i18n.t('lang.lab_error'))
            } else {
              this.$message.error(error)
            }
          })
        } else {
          return false
        }
      })
    },
    // 清空
    resetForm(formName) {
      this.clears = true
      this.ruleForm.typeid = '' // 服务类型
      this.ruleForm.name = '' // 商家名称
      this.ruleForm.phone = '' // 联系方式
      this.ruleForm.address = '' // 地址
      this.ruleForm.imgurl = '' // 图片
      this.ruleForm.recommend = 0 // 推荐状态
      this.ruleForm.preferential = 0 // 优惠状态
      this.ruleForm.reverse2 = '' // 商家详情
      this.ruleForm.alleye = '' // 全景地址
      this.ruleForm.orderby = 1 // 排序
      this.ruleForm.avatar = '' // 图片缓存
      this.fileList = [] // 图片列表清空
      setTimeout(() => {
        this.$refs.ruleForm.clearValidate()
      }, 0)
    },
    // 联系方式只能输入数字
    keyTP() {
      // 仅保留数字
      this.ruleForm.phone = this.ruleForm.phone.replace(/[^\d]/g, '')
    },
  
    // 内容字数提示
    onEditorChange(event) {
      event.quill.deleteText(10000, 4)
      if (this.ruleForm.content === '') {
        this.isLength = 0
      } else {
        this.isLength = event.quill.getLength() - 1
      }
    },
  },
  // 富文本字数限制显示位置
  mounted() {
    addQuillTitle()
  }
}
</script>

<style lang="scss">
.peripheralEdit {
  .item-width{
    width: 80%;
  }
}
</style>